import React from 'react';
import { Modal } from 'react-bootstrap';

const ModalComponent = (props) => {
  const {
    header,
    body,
    footer,
    show,
    canClose = true,
    onHide = () => {},
    scroll,
    dialogClassName,
    bodyStyle,
    ...restOfProps
  } = props;

  const modalStyle = scroll && show ? { display: 'block' } : null;

  const handleHide = () => {
    if (!canClose) return;
    onHide(false);
  };

  return (
    <Modal
      dialogClassName={dialogClassName || ''}
      style={modalStyle}
      show={show}
      onHide={handleHide}
      backdrop={canClose ? true : 'static'}
      keyboard={canClose}
      {...restOfProps}
    >
      <Modal.Header className="bg-complement-3">
        <Modal.Title style={{ width: '100%' }}>{header}</Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={
          bodyStyle
            ? bodyStyle
            : scroll
              ? { height: 'auto', maxHeight: '85vh', overflowY: 'auto' }
              : { maxWidth: '100%' }
        }
      >
        {body}
      </Modal.Body>

      <Modal.Footer>{footer}</Modal.Footer>
    </Modal>
  );
};

export default ModalComponent;
